<template>
  <div class="dynamic_grid">
    <div class="row mb-2">
        <div class="col-lg-2 mt-3 col-6 col-md-5">
          <div v-if="gridMainConfig.pagination" class="input-group mt-2 page-size" style="height: 45px">
            <span class="input-group-text">Page Size</span>
            <select class="form-select" v-model="pageSize">
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="30">30</option>
              <option :value="40">40</option>
            </select>
          </div>
        </div>
        <div class="col-lg-6 col-tab"></div>
        <div class="col-lg-4 mt-md-3 col-md-12">
          <div class="input-group">
            {{gridData.type}}
            <select class="form-select" v-model="filter_column" @change="filter_query = ''">
              <option :value="null">All Filter</option>
              <option v-for="f_col in f_cols" :key="f_col" >{{ f_col }}</option>
            </select>
            <span class="input-group-text">=</span>
            <div class="form-control" style="text-align: center;">
              <input :class="get_filterColumnClassToSearchInputType()" :type="get_filterColumnTypeToSearchInputType()" v-model="filter_query" placeholder="Search">
            </div>
          </div>
      </div>
    </div>
      <table class="table table-bordered table-font table-striped table-scroll" id="DynamicTable">
        <thead>
        <tr>
          <th v-for="(column, index) in gridconfig" :key="index"  @click="sortList(column.fieldName)">
            <div v-if="gridMainConfig.sorting" style="display: inline-flex;">
              {{column.fieldTitle }}&nbsp; &#8597;
                      <!--<font-awesome-icon v-if="asc" icon="sort-down" class="icon" />
                      <font-awesome-icon v-else icon="sort-up" class="icon"/>-->
            </div>
            <div v-else>
              {{column.fieldTitle }}
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, index) in rows" :key="index"  @click="tryUpdate(row)" style="cursor: pointer">
          <td v-for="(column, indexColumn) in columns" :key="indexColumn" >
            <div v-if="column.type === 'password'">
              <span class="hidetext">{{row[column.fieldName]}}</span>
            </div>
            <div v-else-if="column.type === 'boolean'">
              <font-awesome-icon v-if="row[column.icon] != null" :icon="row[column.fieldName] == true ? 'check' : 'times'"
                                 :color="row[column.fieldName] == true ? '#538c79' : '#b66666'"
                                 size="lg" class="icon"
              />
            </div>
            <div v-else-if="column.type ==='datetime'">
              {{row[column.fieldName] | shortFormatDateNumeric}}
            </div>
            <div v-else>
              {{row[column.fieldName]}}
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="col-12" v-if="rows.length < 1" style="text-align: center">
        <p style="font-size: 18px;">No results found!</p>
      </div>
      <!--
        <div style="float: right">
          <div class="card-footer pb-0 pt-3">
            <jw-pagination :items="items"  @changePage="onChangePage" :styles="customStyles"></jw-pagination>
          </div>
        </div>
      -->
      <div v-if="gridMainConfig.pagination && rows.length >= 0" style="float: right">
        <ul class="pagination">
          <li class="page-item">
            <button type="button" class="page-link test" @click="prev" :class="currentPage <= 1 ? 'disabled' : ''"> Previous </button>
          </li>
          <li class="page-item">
            <button type="button" :style="currentPage === pageNumber ? 'color:#f5f5f5; background-color:#56759c' : 'color:#6a85a7'"   class="page-link" v-for="pageNumber in pages" :key="pageNumber.id" @click="currentPage = pageNumber">
              {{pageNumber}}
            </button>
          </li>
          <li class="page-item">
            <button type="button" @click="next" :class="currentPage >= pages.length ? 'disabled' : ''" class="page-link test"> Next </button>
          </li>
        </ul>
      </div>
  </div>
</template>

<script>
import {loadingMixin} from "../../utils/mixins";
/*const customStyles = {
  a:{
    color:'#110e70'
  },
};*/
export default {
  name: "DynamicTable",
  mixins: [loadingMixin],
  props:['gridconfig','gridData','gridMainConfig'],
  data() {
    return {
      filter_column: null,
      filter_query: null,
      items: this.gridData,
      columns : this.gridconfig,
      currentPage: 1,
      pageSize: 10,
      pages: [],
      sortedbyASC: true,
      asc:true,
      //customStyles,
      //dene : [],
    }
  },
  created(){
    console.log(this.gridData),
    console.log(this.gridconfig)
    console.log(this.gridMainConfig)
  },
  computed: {
    f_cols() {
      let field = [];
      for (let i=0; i<this.columns.length; i++ ){
        field.push(this.columns[i].fieldName);
      }
      return field;
    },
    rows() {
      if (!this.items.length) {
        return []
      }
      if(this.gridMainConfig.pagination) {
        return this.paginate(this.items.filter(item =>{
            this.pages = [];
            this.setPages();
            let props = (this.filter_query && this.filter_column) ? [item[this.filter_column]] : Object.values(item)
              return props.some(prop => !this.filter_query || ((typeof prop === 'string') ?
                  prop.toLowerCase().includes(this.filter_query.toLowerCase()) : prop.toString(10).includes(this.filter_query)))
        }
        ))
      }

      return this.items.filter(item => {
        let props = (this.filter_query && this.filter_column) ? [item[this.filter_column]] : Object.values(item)
        return props.some(prop => !this.filter_query || ((typeof prop === 'string') ?
            prop.toLowerCase().includes(this.filter_query.toLowerCase()) : prop.toString(10).includes(this.filter_query)))
      })

    },
  },

  methods: {
    tryUpdate(dynamicValue) {
      this.$emit('dynamic-button', dynamicValue);
    },
    sortList(sortBy) {
      if(this.gridMainConfig.sorting){
        if (this.sortedbyASC) {
          this.items.sort((x, y) => (x[sortBy] > y[sortBy] ? -1 : 1));
          this.sortedbyASC = false;
          this.asc = false
        } else {
          this.items.sort((x, y) => (x[sortBy] < y[sortBy] ? -1 : 1));
          this.sortedbyASC = true;
          this.asc = true
        }
      }
    },
    /*
    onChangePage(dene) {
      this.dene = dene;
    },
    filteredUser(){
      if (!this.items.length) {
        return []
      }
      this.dene = this.items.filter(item => {
            this.pages = [];
            this.setPages();
            let props = (this.filter_query && this.filter_column) ? [item[this.filter_column]] : Object.values(item)
            return props.some(prop => !this.filter_query || ((typeof prop === 'string') ? prop.toLowerCase().includes(this.filter_query.toLowerCase()) : prop.toString(10).includes(this.filter_query)))
          })
    },
    */
    setPages () {
      let numberOfPages = Math.ceil(this.items.length / this.pageSize)
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index)
      }
    },
    paginate (rows) {
      let currentPage = this.currentPage;
      let pageSize = this.pageSize;
      let from = (currentPage * pageSize) - pageSize;
      let to = (currentPage * pageSize);
      return  rows.slice(from, to);
    },
    prev() {
      this.currentPage--;
    },
    next() {
      this.currentPage ++;
       this.setPages();
    },
    get_filterColumnClassToSearchInputType() {
      let input_Class = "form-control"
      let column = "string";
      if (this.filter_column !== null) {
        try {
          column = this.columns.find(x => x.fieldName === this.filter_column);
        }catch (e){
          console.log(e.message)
        }
        switch (column.type) {
          case 'int':
            input_Class = "form-control";
            break;
          case 'string':
            input_Class = "form-control";
            break;
          case 'boolean':
            input_Class = "form-check-input";
            break;
          default:
            input_Class = "form-control";
        }
      }
      return input_Class;
    },
    get_filterColumnTypeToSearchInputType() {
      let input_Type = "search";
      let column = "string";
      if (this.filter_column !== null) {
        try {
          column = this.columns.find(x => x.fieldName === this.filter_column);
        }catch (e){
          console.log(e.message)
        }

        switch (column.type) {
          case 'int':
            input_Type = "number";
            break;
          case 'string':
            input_Type = "text";
            break;
          case 'datetime':
            input_Type = "date";
            break;
          case 'boolean':
            input_Type = "checkbox";
            break;
          default:
            input_Type = "search";
        }

      }

      return input_Type;
    }

  },

}
</script>

<style scoped>
  .hidetext {
    -webkit-text-security: disc;
  }
  .page-link{
    color: #4a81a8;
  }
  table td,
  table th {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .table-striped>tbody>tr:nth-of-type(odd)>* {
    --bs-table-accent-bg: #b9c3cd1f;
  }
  @media (max-width: 767px) {
    .page-size{
      display: none;
    }
  }
</style>
